<template>
  <FixPDC />
</template>

<script>
import FixPDC from '../../components/pratiche/gestione-pdc/fix/FixPDC.vue'

export default {
  components: {
    FixPDC
  },
  mounted() {
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  }
}
</script>
